const MONITORING_DATE_TTL = 24 * 60 * 60 * 1000

export const getMonitoringDateSetting = (key, defaultValue) => {
  try {
    const rawValue = window.localStorage.getItem(key)

    if (rawValue) {
      const parsedValue = JSON.parse(rawValue)
      const savedAt = new Date(parsedValue?.date).getTime()

      if (
          Number.isFinite(savedAt) &&
          Date.now() - savedAt < MONITORING_DATE_TTL
      ) {
        return parsedValue.value ?? defaultValue
      }
    }
  } catch (error) {
    try {
      window.localStorage.removeItem(key)
    } catch (removeError) {
      return defaultValue
    }
  }

  setMonitoringDateSetting(key, defaultValue)

  return defaultValue
}

export const setMonitoringDateSetting = (key, value) => {
  window.localStorage.setItem(
      key,
      JSON.stringify({
        value,
        date: new Date().toISOString(),
      })
  )
}

export const formatMonitoringDateForPicker = (date) => {
  return String(date)
      .replace(/^(\d{4})\.(\d{2})\.(\d{2})$/, '$1-$2-$3')
      .replace(/^(\d{2})\.(\d{2})\.(\d{4})$/, '$3-$2-$1')
}
